import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import SubmissionSuccess from "./pages/SubmissionSuccess";
import ThankYou from "./pages/ThankYou";
import PaymentPage from "./pages/paymentPage";
import SuccessPage from "./pages/SuccessPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PaymentPage />} />
        
          <Route path="/thank-you" element={<ThankYou />} />   {/* NEW */}
          <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
